<template>
  <div class="container" :style="containerStyleObj">
    <!--头部-->
    <Row class="title-wrap" :style="titleWrapStyleObj" ref="titleWrap">
      <Col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
      <div class="title" :style="titleStyleObj">
        <img src="../../assets/images/databoard/head-left-icon.png" />
        <span v-on:click="handleFullScreen()">{{
          regionData.school_name
          }}</span>
        <img src="../../assets/images/databoard/head-right-icon.png" />
      </div>
      <div class="logo" :style="logoStyleObj">
        <!--<img src="../../assets/images/databoard/class30-logo.png" />-->
        <template v-if="channel == 'telit'">
          <img :src="`${logoPath}?${timestamp}`" />
          <span class="split-line"></span>
          <img :src="`${yjtLogoPath}?${timestamp}`" />
          <span class="split-line"></span>
          <img src="../../assets/images/databoard/ai-logo.png" style="margin: 3.5px 0" />
        </template>
        <template v-else-if="channel == 'zkxc'">
          <img :src="`${logoPath}?${timestamp}`" />
          <span class="split-line"></span>
          <img src="../../assets/images/databoard/ai_logo-zkxc.png" style="margin: 3.5px 0" />
        </template>
        <template v-else>
          <img :src="`${logoPath}?${timestamp}`" />
          <span class="split-line"></span>
          <img src="../../assets/images/databoard/ai-logo.png" style="margin: 3.5px 0" />
        </template>
      </div>
      <div class="full-screen" v-on:click="handleFullScreen()">
        <template v-if="!fullscreen">
          <span class="full-icon"><img src="../../assets/images/databoard/full-screen-icon.png" /></span>
          <span class="full-title">全屏</span>
        </template>
        <template v-else>
          <span class="full-icon"><img src="../../assets/images/databoard/exit-full-screen-icon.png" /></span>
          <span class="full-title">取消全屏</span>
        </template>
      </div>
      <div class="statis-report" v-on:click="gotoSchoolList()">
        <span class="full-title">统计报表</span>
      </div>
      <div class="future-classroom" v-on:click="gotoAreaMonitor()"
        v-if="regionData.school_name === '赣榆区智慧化助学系统教学大数据' && areaMonitorEnabled">
        <span class="full-title">区域监管</span>
      </div>
      </Col>
    </Row>
    <Row :gutter="20" class="statistic-wrap" :style="statisticWrapStyleObj">
      <Col :xs="{ span: 6 }" :sm="{ span: 6 }" :md="{ span: 6 }" :lg="{ span: 6 }" style="padding-right: 0px">
      <!--校本书库统计-->
      <ebook-statis :ebookCountList="ebookCountList" :titleHeight="titleHeight"
        :screenHeight="screenHeight"></ebook-statis>
      <!--课件统计-->
      <courseware-statis :teaCourseware="teaCourseware" :teaCoursewareCount="teaCoursewareCount"
        :titleHeight="titleHeight" :screenHeight="screenHeight"></courseware-statis>
      <!--教师课堂行为分析-->
      <tea-classroom-behavior :teaClassBehavior="teaClassBehavior" :titleHeight="titleHeight"
        :screenHeight="screenHeight"></tea-classroom-behavior>
      </Col>
      <Col :xs="{ span: 12 }" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
      <div class="statis-count" :style="statisCountStyleObj" v-if="isLoading">
        <Col :xs="{ span: 12 }" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <div class="count-wrap" style="margin-right: 10px">
          <ul>
            <li v-on:click="lookRegionStatisInfo('school')" style="width: 50%">
              <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                :nameStyleObj="nameStyleObj" :startDataVal="-1" :end-val="agentData[0].school_count" intro-text="学校总数"
                cardType="newDataSupervise" :isConvert="isConvert"></infor-card>
              <span class="right-border"></span>
            </li>
            <li v-on:click="lookRegionStatisInfo('class')" style="width: 50%">
              <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                :nameStyleObj="nameStyleObj" :startDataVal="agentData[0].use_class_num"
                :end-val="agentData[0].class_num" intro-text="使用班级数/总数" cardType="newDataSupervise"
                :isConvert="isConvert"></infor-card>
            </li>
          </ul>
        </div>
        </Col>
        <Col :xs="{ span: 12 }" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <div class="count-wrap">
          <ul>
            <li v-on:click="lookRegionStatisInfo('teacher')" style="width: 50%">
              <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                :nameStyleObj="nameStyleObj" :startDataVal="agentData[0].use_tea_num" :end-val="agentData[0].tea_num"
                intro-text="使用教师数/总数" cardType="newDataSupervise" :isConvert="isConvert"></infor-card>
              <span class="right-border"></span>
            </li>
            <li v-on:click="lookRegionStatisInfo('student')" style="width: 50%">
              <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                :nameStyleObj="nameStyleObj" :startDataVal="agentData[0].use_stu_num" :end-val="agentData[0].stu_num"
                intro-text="使用学生数/总数" cardType="newDataSupervise" :isConvert="isConvert"></infor-card>
            </li>
          </ul>
        </div>
        </Col>
      </div>
      <!--教师操作动态-->
      <div class="tea-oper-dym tea-oper-dym-bg" :style="teaOperDymStyleObj">
        <!-- <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg1">
          <span>教学动态</span>
        </div> -->
        <div class="dym-content" :style="teaOperDymStyleObj">
          <tea-dynamic :dynamicData="dynamicData" @openPreview="openPreview" @lookInterInfo="lookInterInfo"
            ref="dynamicRef"></tea-dynamic>
        </div>
      </div>
      <pie-item name="teaBehavior" :titleHeight="titleHeight" :paramTeaData="teaBehaviorData"
        :paramStuData="stuBehaviorData" :form="'region'" :screenHeight="screenHeight"></pie-item>
      </Col>
      <Col :xs="{ span: 6 }" :sm="{ span: 6 }" :md="{ span: 6 }" :lg="{ span: 6 }" style="padding-left: 0">
      <!--学段活跃情况-->
      <active-period-statis v-if="$route.query.agentId || $store.getters.agentId" ref="activePeriodStatis"
        :evlPer="evlPer" :titleHeight="titleHeight" :screenHeight="screenHeight"
        :curYear="curYear"></active-period-statis>
      <!--学校活跃情况-->
      <active-school-statis v-if="$route.query.agentId || $store.getters.agentId" ref="activeSchoolStatis"
        :evlPer="evlPer" :titleHeight="titleHeight" :screenHeight="screenHeight"
        :curYear="curYear"></active-school-statis>
      <!--学科活跃情况-->
      <active-subject-statis v-if="$route.query.agentId || $store.getters.agentId" ref="activeSubjectStatis"
        :evlPer="evlPer" :titleHeight="titleHeight" :screenHeight="screenHeight"
        :curYear="curYear"></active-subject-statis>
      </Col>
    </Row>
    <!--课堂互动弹框-->
    <div v-show="isShowModal">
      <div class="mask-box"></div>
      <div class="panel-box">
        <div class="close-btn">
          <img class="logo-img" src="../../assets/images/databoard/close_btn.png" width="100%" height="100%"
            v-on:click="closeWin" />
        </div>
        <div class="panel-main">
          <div class="icon-box-wrap">
            <img class="icon-box" :src="currentInter.evaluate_type_icon" width="100%" height="100%"
              v-if="currentInter.evaluate_type_icon != ''" />
            <p class="icon-txt">{{ currentInter.evaluate_type_name }}</p>
          </div>
          <div class="info-box">
            <p>
              <span class="txt-item">{{ currentInter.school_name }}</span>
              <span class="txt-item">{{ currentInter.teacher_real_name }}老师</span>
              对
              <span class="txt-item">{{ currentInter.student_real_name }}</span>
              学生
            </p>
            <p>进行了 “ {{ currentInter.evalContent }} ” 的评价</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 预览轮播 -->
    <dt-preview-slider ref="previewSlider" :previewMode="previewMode" :previewVideoMode="previewVideoMode"
      :videoSrc="videoSrc" @closePreview="closePreview"></dt-preview-slider>
  </div>
</template>

<script>
import inforCard from "../../components/inforCard.vue"; //数据卡片
import {
  findSummaryByAgent,
  findRegionData,
  fetchBehaviorData
} from "../../service/bigDataApi.js";
import { getOperOriginInfoAPI } from "../../service/api.js";
import axios from "axios";

//校本书库统计
import ebookStatis from "./modules/ebookStatis";
//课堂评价分析
import classroomEva from "./modules/classroomEva";
//课堂行为分析
import classroomInter from "./modules/classroomInter";
//课件统计
import coursewareStatis from "./modules/coursewareStatis";
//作业统计
import homeworkStatis from "./modules/homeworkStatis";
//实时动态
import teaDynamic from "./modules/teaDynamic.vue";
//教师课堂行为分析
import teaClassroomBehavior from "./modules/teaClassroomBehavior";
//教师行为，学生行为
import pieItem from "./modules/pieItem copy.vue";
import activePeriodStatis from "./modules/activePeriodStatis";
import activeSchoolStatis from "./modules/activeSchoolStatis";
import activeSubjectStatis from "./modules/activeSubjectStatis";

// const previewSlider = () => import("./table/baseData/previewSlider");

export default {
  name: "school-index",
  components: {
    inforCard, //数据卡片
    ebookStatis,
    classroomEva,
    classroomInter,
    coursewareStatis,
    homeworkStatis,
    teaClassroomBehavior,
    teaDynamic,
    pieItem,
    // previewSlider,
    activePeriodStatis,
    activeSchoolStatis,
    activeSubjectStatis,
  },
  computed: {},
  data() {
    return {
      isConvert: 1, //是否转换数字
      fullscreen: false,
      regionData: {},
      agentData: [],
      evlPer: 80,
      isLoading: false,
      teaCourseware: [], //教师课件
      teaClassBehavior: [], //教师课堂行为
      dynamicData: [], //实时动态
      teaBehaviorData: [], //教师行为
      stuBehaviorData: [], //学生行为
      ebookCountList: [], //校本书库
      top: [],
      left: [130, 140, 150, 160, 170, 180, 190, 200, 210, 230],
      color: ["#FFF", "#00d8ff", "#ffce23"],
      scrollInterval: {}, //动态滚动区间,
      scrollIngDynamicList: [],
      screenHeight: document.body.clientHeight, // 屏幕默认宽度
      containerStyleObj: {
        height: "",
      },
      titleWrapStyleObj: {
        height: "",
      },
      titleStyleObj: {
        height: "",
      },
      logoStyleObj: {
        height: "",
      },
      statisticWrapStyleObj: {
        height: "",
        margin: "0px 0px 10px 0px",
      },
      statisCountStyleObj: {
        height: "",
      },
      numStyleObj: {
        height: "",
        lineHeight: "",
      },
      nameStyleObj: {
        height: "",
        lineHeight: "",
      },
      teaOperDymStyleObj: {
        height: "",
      },
      dymContentStyleObj: {
        height: "",
      },
      teaCoursewareCount: "", //教师课件总数
      titleHeight: 0,
      countWeight: 700,
      previewMode: false,
      previewVideoMode: false,
      videoSrc: "",
      isShowModal: false,
      currentInter: {},
      tabsName: "", //标签页名称
      schoolCode: this.$route.params.schoolCode,
      schoolId: this.$route.params.schoolId, //学校id
      logoPath: process.env.VUE_APP_DASH_LOGO_PATH,
      yjtLogoPath: process.env.VUE_APP_DASH_YJT_LOGO_PATH,
      timestamp: new Date().getTime(),
      channel: process.env.VUE_APP_CHANNEL,
      areaMonitorEnabled: false,
    };
  },
  created() { },
  watch: {},
  methods: {
    /**
     * 获取课堂行为分析
     */
    async getBehaviorData() {
      let _this = this;
      let params = {
        agentId: _this.$route.query.agentId || _this.$store.getters.agentId,
      };
      await fetchBehaviorData(params)
        .then(function (data) {
          _this.teaClassBehavior = data;
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取区域监管入口开关
     */
    async getAreaMonitorConfig() {
      const url = `https://fs.iclass30.com/aliba/console/json/gydata.json?v=${Date.now()}`;
      await axios
        .get(url)
        .then((res) => {
          const data = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
          const state = data && data.data ? data.data.state : data.state;
          this.areaMonitorEnabled = String(state) === "1";
        })
        .catch(() => {
          this.areaMonitorEnabled = false;
        });
    },
    /**
     * 获取区域数据展板数据
     */
    async getRegionData() {
      let _this = this;
      let params = {
        agentId: _this.$route.query.agentId || _this.$store.getters.agentId,
        agentName: _this.$route.query.agentName || _this.$store.getters.agentName,
      };
      await findRegionData(params)
        .then(function (data) {
          _this.regionData = data;
          _this.ebookCountList = JSON.parse(_this.regionData.ebook_count_group);
          _this.teaCourseware = JSON.parse(_this.regionData.tea_courseware);
          //获取课件总数
          _this.teaCoursewareCount = _this.regionData.courseware_count;
          // _this.teaClassBehavior = JSON.parse(
          //   _this.regionData.tea_class_behavior
          // );
          _this.dynamicData = JSON.parse(data.dynamic);
          _this.teaBehaviorData = JSON.parse(data.tea_behavior);
          _this.stuBehaviorData = JSON.parse(data.stu_behavior);
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取数据展板所有统计数据
     */
    async getSummaryByAgent() {
      let _this = this;
      let params = {
        agentId: _this.$route.query.agentId || _this.$store.getters.agentId,
      };
      await findSummaryByAgent(params)
        .then(function (data) {
          _this.isLoading = true;
          _this.agentData = data;
        })
        .catch(function (error) {
          _this.isLoading = true;
          _this.$Message.error(error.message);
        });
    },
    /**
     * 全屏
     */
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    /**
     * 查看学校列表
     */
    gotoSchoolList() {
      let _this = this;
      let routeData = this.$router.resolve({
        name: "schoolList",
      });
      window.open(routeData.href, "_blank");
    },
    gotoAreaMonitor() {
      window.open("https://ganyu.iclass30.com/areateachmonitor/", "_blank");
    },
    /**
     * 查看区域数据展板的教师学生学校和班级数据
     */
    lookRegionStatisInfo(val) {
      let _this = this;
      let routeData = this.$router.resolve({
        name: "regiondatalist",
        query: {
          agentId: _this.$route.query.agentId || _this.$store.getters.agentId,
          agentName: _this.$route.query.agentName || _this.$store.getters.agentName,
        },
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 预览资源
     */
    openPreview(resultUrl, count, type) {
      // type 0:其他 1.文档 2.视频 3.音频 4.图片
      if (type === 2) {
        this.previewVideoMode = true;
        this.videoSrc = resultUrl + "/video.mp4";
        return;
      } else if (type === 3) {
        this.$Message.error("音频文件，暂时无法预览！");
        return;
      }
      if (!count) {
        this.$Message.error("暂无缩略图，无法预览！");
        return;
      }
      this.previewMode = true;
      this.$refs.previewSlider.swiperInit(resultUrl, count);
    },
    // 关闭预览
    closePreview(type) {
      this[type] = false;
      // //继续开始滚动
      // this.$refs.dynamicRef.hoverEvent();
      // this.$refs.dynamicRef.mouseleaveEvent();
    },
    /**
     * 查看互动详情
     */
    lookInterInfo(interObj) {
      this.isShowModal = true;
      this.currentInter = interObj;
      //互动评价
      this.currentInter.evalContent = this.currentInter.evaluate_type_name;
    },
    /**
     * 关闭弹窗
     */
    closeWin() {
      this.isShowModal = false;
      this.currentInter = {};
      // //继续开始滚动
      // this.$refs.dynamicRef.hoverEvent();
      // this.$refs.dynamicRef.mouseleaveEvent();
    },
    /**
     * @name 根据运营获取代理商信息
     */
    async getOperOriginInfo() {
      let _this = this;
      let params = {
        operId: _this.$store.getters.userId,
      };
      await getOperOriginInfoAPI(params)
        .then(function (data) {
          _this.$store.commit("SET_AGENTID", data.originId);
          _this.$store.commit("SET_AGENTName", data.originName);
          //获取区域数据展板所有统计数据
          _this.getRegionData();
          _this.getBehaviorData();
          //获取区域数据展板横框数据
          _this.getSummaryByAgent();
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * @name 获取代理商信息
     */
    getData() {
      if (this.$store.getters.userType == 5) {
        this.getOperOriginInfo();
      } else {
        const agentId = this.$route.query.agentId || this.$store.getters.agentId;
        const agentName =
          this.$route.query.agentName || this.$store.getters.agentName;
        this.$store.commit("SET_AGENTID", agentId);
        this.$store.commit("SET_AGENTName", agentName);
        //获取区域数据展板所有统计数据
        this.getRegionData();
        this.getBehaviorData();
        //获取区域数据展板横框数据
        this.getSummaryByAgent();
      }
    },
    /**
     * @name 获取当前学年
     */
    // async getCurrentSchoolYear() {
    //   let curYear = '';
    //   const res = await findSchoolYears();
    //   if (res.length > 0) {
    //     curYear = res[0];
    //   }
    //   this.curYear = curYear;
    // }
  },
  async mounted() {
    const _this = this;
    this.$nextTick(() => {
      let windowHeight = window.innerHeight;
      if (windowHeight < 900) {
        windowHeight = 938;
        document.getElementsByTagName("body")[0].className = "active";
      }
      let titleHeight = 128;
      let statisticHeight = windowHeight - titleHeight - 10;
      let statisHeight = windowHeight / 12.5;
      let dymHeight = statisticHeight - statisHeight - statisticHeight / 3 - 20;
      this.titleHeight = titleHeight;
      this.containerStyleObj.height = windowHeight + "px";
      this.titleWrapStyleObj.height = titleHeight + "px";
      this.titleStyleObj.height = titleHeight * 0.4 - 10 + "px";
      this.logoStyleObj.height = titleHeight * 0.3 + "px";
      this.statisticWrapStyleObj.height = statisticHeight + "px";
      this.statisCountStyleObj.height = statisHeight + "px";
      this.numStyleObj.height = statisHeight * 0.6 + "px";
      this.numStyleObj.lineHeight = statisHeight * 0.6 + "px";
      this.nameStyleObj.height = statisHeight * 0.4 + "px";
      this.nameStyleObj.lineHeight = statisHeight * 0.4 + "px";
      this.teaOperDymStyleObj.height = dymHeight + "px";
      this.dymContentStyleObj.height = dymHeight - 49 + "px";
      this.getData();
      this.getAreaMonitorConfig();
    });

    // 注：window.onresize只能在项目内触发1次
    window.onresize = function windowResize() {
      // 通过捕获系统的onresize事件触发我们需要执行的事件
      let windowHeight = document.body.clientHeight;
      if (windowHeight < 900) {
        windowHeight = 938;
        document.getElementsByTagName("body")[0].className = "active";
      }
      _this.screenHeight = windowHeight;
      let titleHeight = 128;
      let statisticHeight = windowHeight - titleHeight - 10;
      let statisHeight = windowHeight / 12.5;
      let dymHeight = statisticHeight - statisHeight - statisticHeight / 3 - 20;
      _this.titleHeight = titleHeight;
      _this.containerStyleObj.height = windowHeight + "px";
      _this.titleWrapStyleObj.height = titleHeight + "px";
      _this.titleStyleObj.height = titleHeight * 0.4 - 10 + "px";
      _this.logoStyleObj.height = titleHeight * 0.3 + "px";
      _this.statisticWrapStyleObj.height = statisticHeight + "px";
      _this.statisCountStyleObj.height = statisHeight + "px";
      _this.numStyleObj.height = statisHeight * 0.6 + "px";
      _this.numStyleObj.lineHeight = statisHeight * 0.6 + "px";
      _this.nameStyleObj.height = statisHeight * 0.4 + "px";
      _this.nameStyleObj.lineHeight = statisHeight * 0.4 + "px";
      _this.teaOperDymStyleObj.height = dymHeight + "px";
      _this.dymContentStyleObj.height = dymHeight - 49 + "px";
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../style/databoard";
@import "../../style/detailPage";

.panel-box {
  background-image: url("../../assets/images/databoard/modal-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

@font-face {
  font-family: MaravaleExpanded;
  src: url("../../assets/fonts/digifaw.ttf"); //字体路径
}

.container {
  background-image: url("../../assets/images/databoard/bg5.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.title-wrap {
  background-image: url("../../assets/images/databoard/head-bg.png");
  background-repeat: no-repeat;
  background-position: top;
}

.count-wrap {
  height: 100%;
  background-image: url("../../assets/images/databoard/count-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.full-screen {
  background-image: url("../../assets/images/databoard/full-screen-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.statis-report {
  background-image: url("../../assets/images/databoard/full-screen-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.future-classroom {
  background-image: url("../../assets/images/databoard/full-screen-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.tea-oper-dym-bg {
  border: unset;
  box-shadow: unset;
  background: unset;
}

.bg1 {
  background-image: url("../../assets/images/databoard/title-bg1.png");
}
</style>

<style lang="scss">
body {
  background-color: #000 !important;
  overflow-x: hidden;
  overflow-y: hidden;
}

.active {
  overflow-x: auto;
  overflow-y: auto;
}
</style>
